import { helper } from '@ember/component/helper';
import abbreviateNumber from '../utils/abbreviate-number';

export function abbreviate(params) {
  return abbreviateNumber(params[0]);
}

export default helper(abbreviate);
